<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row>
          <span>اطلاعات اولیه</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense clearable
              autocomplete="off" @click:clear="clearDateTime('arriveToPatientTime')"
              clear-icon="mdi-close-circle-outline" v-model="tempArriveToPatientTime"
              @focus="showArriveToPatientTime = true" @click="showArriveToPatientTime = true"
              label="زمان رسیدن بر بالین بیمار*" prepend-inner-icon="mdi-calendar-range mdi-18px">
              <template slot="append">
                <v-icon @click="showArriveToPatientTime = true" class="calender-background ml-n3 mt-n2" color="white">
                  mdi-calendar-range mdi-18px
                </v-icon>
              </template>
            </v-text-field>
            <date-picker :max="maxDateTime" :show="showArriveToPatientTime" simple v-model="patient.arriveToPatientTime"
              type="datetime" @open="onOpen" @change="dateTimeChange('arriveToPatientTime')" :editable="true"
              format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
              custom-input="#moveFromStationTime-moveFromStationTime" @close="showArriveToPatientTime = false" />
          </v-col>
          <v-col cols="4">
            <v-text-field dense outlined label="شکایت اصلی*" clearable clear-icon="mdi-close-circle-outline"
              v-model="patient.chiefComplaintText" autocomplete="off"
              prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense clearable
              autocomplete="off" @click:clear="clearDateTime('dateOfOnset')" clear-icon="mdi-close-circle-outline"
              v-model="tempDateOfOnset" @focus="showDateOfOnset = true" @click="showDateOfOnset = true"
              label="زمان شروع علائم" prepend-inner-icon="mdi-calendar-range mdi-18px">
              <template slot="append">
                <v-icon @click="showDateOfOnset = true" class="calender-background ml-n3 mt-n2" color="white">
                  mdi-calendar-range mdi-18px
                </v-icon>
              </template>
            </v-text-field>
            <date-picker :max="maxDateTime" :show="showDateOfOnset" simple v-model="patient.dateOfOnset" type="datetime"
              @open="onOpen" @change="dateTimeChange('dateOfOnset')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
              display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
              @close="showDateOfOnset = false" />
          </v-col>
        </v-row>
        <v-row>
          <span>مشخصات عمومی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="4" class="mt-n2">
            <v-checkbox v-model="patient.isUnknown" label="مجهول الهویه" hide-details></v-checkbox>
          </v-col>
          <v-col cols="4" v-if="!patient.isUnknown">
            <v-text-field hide-details dense outlined v-model="patient.firstName" label="نام *" clearable
              clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4" v-if="!patient.isUnknown">
            <v-text-field hide-details dense outlined v-model="patient.lastName" label="نام خانوادگی *" clearable
              clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-account mdi-18px"></v-text-field>
          </v-col>

          <v-col cols="4" class="mt-n2">
            <v-text-field hide-details dense outlined @keypress="isNumber($event)" v-model="patient.yearOfAge"
              label="حدود سن (سال)" maxlength="3" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4" class="mt-n2">
            <v-text-field hide-details dense outlined @keypress="isNumber($event)" v-model="patient.monthOfAge"
              label="حدود سن (ماه)" maxlength="2" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4" class="mt-n2">
            <v-row>
              <v-col cols="3">
                <v-checkbox class="mt-2" v-model="isChildren" label="نوزاد" hide-details></v-checkbox>
              </v-col>
              <v-col cols="9">
                <v-text-field :disabled="!isChildren" hide-details dense outlined @keypress="isNumber($event)"
                  v-model="patient.ageTotalDays" label="حدود سن (روز)" maxlength="2" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" class="mt-n2" v-if="!patient.isUnknown">
            <v-text-field hide-details dense outlined @keypress="isNumber($event)" maxlength="10"
              v-model="patient.nationalCode" label="کد ملی" clearable clear-icon="mdi-close-circle-outline"
              prepend-inner-icon="mdi-card-account-details mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4" class="mt-n2" v-if="!patient.isUnknown">
            <v-autocomplete hide-details :items="nationalityList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="id" label="ملیت *" clearable clear-icon="mdi-close-circle-outline"
              v-model="patient.nationality" autocomplete="off"
              prepend-inner-icon="mdi-account-question mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4" class="mt-n2" v-if="!patient.isUnknown">
            <v-autocomplete hide-details :items="genderFollowUpItems" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="id" label="جنسیت *" clearable clear-icon="mdi-close-circle-outline"
              v-model="patient.gender" autocomplete="off"
              prepend-inner-icon="mdi-human-male-female mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4" class="mt-n2" v-if="patient.isUnknown == true">
            <v-text-field hide-details dense outlined v-model="patient.clothesColorAndType" label="نوع و رنگ لباس*"
              clearable clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-receipt mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4" class="mt-n2" v-if="patient.isUnknown == true">
            <v-text-field hide-details dense outlined v-model="patient.specialCharacteristic" label="مشخصه خاص*"
              clearable clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
          </v-col>
          <v-col cols="4" class="mt-n2" v-if="patient.isUnknown === false">
            <app-date-picker label="تاریخ تولد" inputID="birthDate" :const-value="patient.birthDate"
              v-model="patient.birthDate" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-row>
              <span>مشاوره پزشکی</span>
              <v-divider class="mt-3 mr-3 ml-3"></v-divider>
            </v-row>
          </v-col>
          <v-col cols="4">
            <v-row>
              <span>احیا</span>
              <v-divider class="mt-3 mr-3"></v-divider>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-autocomplete :items="allDoctorConsultationTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense
              outlined item-text="title" item-value="id" label="مشاوره پزشکی" clearable
              clear-icon="mdi-close-circle-outline" v-model="patient.doctorConsultationTypeId" autocomplete="off"
              prepend-inner-icon="mdi-medical-bag mdi-18px"></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete :items="allResuscitationTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
              item-text="title" item-value="id" label="احیا" clearable clear-icon="mdi-close-circle-outline"
              v-model="patient.resuscitationTypeId" autocomplete="off"
              prepend-inner-icon="mdi-medical-bag mdi-18px"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn rounded color="darkColor" dark @click="goToStep2()">ثبت و بعدی</v-btn>
          <v-btn text color="darkColor" @click="backToFollowUpMission()">بازگشت</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AppDatePicker from '@/components/app/DatePicker.vue';
import SharedHelper from '@/Helpers/Shared';
import FollowUpPatientStep1Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep1Helper.js';
import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
import DoctorConsultationTypeMixin from '@/Mixins/FollowUp/DoctorConsultationTypeMixin';
import ResuscitationTypeMixin from '@/Mixins/FollowUp/ResuscitationTypeMixin';
import ShearedMixin from '@/Mixins/Shared.js';
import PatientMixin from '@/Mixins/Doctor/PatientMixin.js';
import PatientDetailMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientDetailMixin.js';
import moment from 'moment';
export default {
  components: { AppDatePicker },
  mixins: [
    SharedHelper,
    ChiefComplaintMixin,
    ShearedMixin,
    DoctorConsultationTypeMixin,
    ResuscitationTypeMixin,
    FollowUpPatientStep1Helper,
    PatientMixin,
    PatientDetailMixin,
  ],
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      if (this.patientId) {
        this.getPatientByIdFunction(this.patientId);
        this.getPatientDetailForStep1(this.patientId);
      }
      this.getListOfChiefComplaintsForOther();
      this.getListOfDoctorConsultationTypesForOther();
      this.getListOfResuscitationTypesForOther();
    },
  },
  computed: {
    maxDateTime() {
      return moment().format('YYYY-MM-DDTHH:mm:ss');
    }
  },
};
</script>
<style scoped>
.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}
</style>
